import React from 'react';
import Heading from "../elements/Heading";

const MobileCoverage = () => {

    return (
        <div className="coverage-map">
            <Heading title="Mobile coverage map" className="text-center">
                <p>To find out if your business has mobile coverage, simply enter your street, suburb or postcode</p>
            </Heading>
            <div className="w-100 d-flex justify-content-center">
                <iframe
                    className="tw-coveragemap"
                    width="1000"
                    height="730"
                    allow="geolocation"
                    src="https://mobilemaps.net.au/ui/geomaps/v1/coverage/index.html?mode=wholesale"
                    style={{ display: 'block', margin: '0px auto !important', border: 'none' }}
                />
            </div>
            <div className="row my-5 text-center">
                <div className="col-12 col-lg-8 col-lg-offset-2">
                    For more information, please refer to our <a href="https://www.exetel.com.au/terms" target="_blank" rel="noreferrer noopener">Terms of Use</a>.
                </div>
            </div>
        </div>
    );

}

export default MobileCoverage;


// WEBPACK FOOTER //
// ./resources/assets/js/mobileFleet/MobileCoverage.js